<template>
    <page :busy="busy" :tabs="tabs" class="reservation-page">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import Page from '../generic/page/page.vue';

export default {
    name: 'ChannelErrors',
    components: {
        Page,
    },
    computed: {
        tabs() {
            return [
                {
                    title: `Reservations`,
                    route: `/app/reservations-list/reservation/`,
                    active:
                        this.$route.path ===
                        `/app/reservations-list/reservation/`,
                },
                {
                    title: `Blocked Periods`,
                    route: `/app/reservations-list/blocked-reservation/`,
                    active:
                        this.$route.path ===
                        `/app/reservations-list/blocked-reservation/`,
                },
            ];
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    mounted() {
        this.$store.dispatch('reservationsStore/fetchPermissions');
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
    },
};
</script>

<style lang="scss" scoped>
.reservation-page {
    :deep(.filter-reservation-status-marker) {
        border-radius: 50%;
        width: 20px;
        height: 20px;
    }

    :deep(.ag-cell-wrapper) {
        font-size: 13px;
    }

    :deep(.filter-by-status-dropdown-item) {
        .dropdown-item {
            display: flex !important;
        }
    }
}
</style>